import { useAllVisits } from '../../api/queries';
import { usePracticeInfo, useVisitModals } from '../../hooks/useVisitModals';
import { VisitListPage } from '../../components/visits/VisitListPage';

export function ActiveVisitsPage() {
  const { hasActivePlan } = usePracticeInfo();
  const { data: visitsData, isLoading } = useAllVisits(hasActivePlan);
  const { openDetail, modals } = useVisitModals();

  return (
    <>
      <VisitListPage
        visits={visitsData?.activeVisits || []}
        isLoading={isLoading}
        emptyMessage="No active visits. Start one with the Instant Visit button above."
        onVisitClick={openDetail}
        heading={<h2><svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: '-2px', marginRight: '0.35rem' }}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>Active Visits</h2>}
      />
      {modals}
    </>
  );
}
